import React from 'react';
import { HobbiesIntroduction } from './HobbiesIntroduction';
import { ProjectCard } from './ProjectCard';

import printing from '../Images/3d_printing_stock.webp';
import mechanical_keyboard from '../Images/Mechanical_Keyboard_tomo.jpeg';
import python_library from '../Images/python_library_logo.svg';
import meal_prep_logo2 from '../Images/Weekly_Meal_Prep_logo.webp';
import financial_logo from '../Images/financial_system_logo.webp';

const hobbyItems = [
  {
    title: 'Financial Data Analysis System',
    subtitle: 'Personal finance platform',
    year: '2024',
    description:
      'Building a system to manage and analyze personal finances, combining software and hardware experiments with real-world data.',
    imageSrc: financial_logo,
    link: '/financialsystem',
    buttonText: 'Read more',
  },
  {
    title: '3D Printing',
    subtitle: 'Practical experiments',
    year: '2024',
    description:
      'Exploring printers, materials, and workflows to make practical objects that improve daily life and stay aesthetically sharp.',
    imageSrc: printing,
    link: '/3dprinting',
    buttonText: 'Read more',
  },
  {
    title: 'Weekly Meal Prep',
    subtitle: 'Healthy and efficient',
    year: '2024',
    description:
      'Optimizing weekly shopping to balance variety, nutrition, and cost while reducing food waste.',
    imageSrc: meal_prep_logo2,
    link: '/mealprep',
    buttonText: 'Read more',
  },
  {
    title: 'Mechanical Keyboards',
    subtitle: 'Builds and design',
    year: '2020',
    description:
      'Custom builds, tuning, and experimentation with layouts and materials on a journey toward the perfect board.',
    imageSrc: mechanical_keyboard,
    link: '/keyboards',
    buttonText: 'Read more',
  },
  {
    title: 'Spanish Conjugator',
    subtitle: 'Python library package',
    year: '2020',
    description:
      'Collaborated with my brother to create a Python library for conjugating Spanish verbs and integrating with learning tools.',
    imageSrc: python_library,
    link: 'https://pypi.org/project/spanishconjugator/',
    buttonText: 'Read more',
  },
];

export function HobbiesContent() {
  return (
    <section className="page-shell">
      <HobbiesIntroduction />
      <div className="cards-grid">
        {hobbyItems.map((item) => (
          <ProjectCard key={item.title} {...item} />
        ))}
      </div>
    </section>
  );
}
